import PropTypes from 'prop-types';
import React from 'react';

import CrLogo from '../../../../assets/images/header/Logo_CR_vertical_AZUL_SEM-SLOGAN_01.png'; // eslint-disable-line
import CorreiosLogo from '../../../../assets/images/logoCorreiosLabel.png';
import { Text, Spacer } from '../../../../shared/components';

export default function DevolutionMethodCard({ methodIndex, devolutions }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <img height={20} src={methodIndex === 1 ? CrLogo : CorreiosLogo} />
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Text.xlarge bold color="var(--color-blue-primary)">
          {devolutions.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false,
          })}
        </Text.xlarge>
        <Spacer.horizontal size={8} />
        <Text.small weak>Devoluções</Text.small>
      </div>
    </div>
  );
}

DevolutionMethodCard.PropTypes = {
  methodIndex: PropTypes.number.isRequired,
  devolutions: PropTypes.number.isRequired,
};
